<template>
    <el-dialog :before-close="cf" :title="config.title + '-审核驳回'" :visible.sync="safs" width="738px">
		<div style="position: relative;">
			<ul>
				<li class="w ofh">
					<span class="fleft Dialogkey" style="line-height: 35px;">
						驳回理由
					</span>
                    <el-radio-group v-model="radio1" class="sel-dialog-content fleft">
						<div class="w  sel-radio" v-for="(item,index) in tableData" :key="index">
							<el-radio :label="item.content">{{ item.content }}</el-radio>
						</div>
						<div class="w sel-radio">
							<el-radio label="其他理由">其他理由（请在详细说明中填写）</el-radio>
						</div>
					</el-radio-group>
				</li>
				<li class="w ofh">
					<span class="fleft Dialogkey">
						驳回详细说明
					</span>
					<div class="fleft defaultbtnworkbg">
						<div>
							<textarea name="" id="" cols="60" rows="10" v-model="text100" Maxlength="100" class="defaultbtnwork"></textarea>
						</div>
						<span class="fright fontcolorg">{{ text100.length }}/100</span>
					</div>
				</li>
			</ul>
        </div>
			<span slot="footer" class="dialog-footer sel-footer">
				<button class="defaultbtn" @click="closefn()">取消</button>
				<button class="defaultbtn defaultbtnactive" @click="contributor">确定驳回</button>
		</span>
    </el-dialog>
</template>
<script>
	export default {
        props:{
            config:Object
        },
		data() {
            return{
                safs:true,
                text100:'',
                radio1:'',
                tableData:[],
			}
		},
		methods: {
			cf(){
				this.closefn();
				return false
			},
            closefn(n){
		
                this.$emit('close',n || '')
            },
            contributor() {
				if(!this.radio1){
					this.$message("请选择驳回理由")
					return;
				}
				let data = {
					access_token: localStorage.getItem("access_token"),
					type: this.config.type,
					id: this.config.id,
					check_status: -1,
					check_reason:this.radio1,
					check_comment:this.text100,
					formats: JSON.stringify({
                        '驳回理由': this.radio1,
                        '备注': this.text100
                    })
				}
                this.api.reviewCheck(data).then(() => {
                    this.closefn('sx')
				})
			},
			getData() {
				//获取子组件表格数据
				var data = {
					access_token: localStorage.getItem("access_token"),
					page: 1,
					limit: 100,
					type:this.config.type,
					status:"1"
				}
				this.api.reviewreason(data).then(da=> {
					this.tableData = da.data;
				})
			},
		},

		mounted() {
	
            this.getData();
		}
	}
</script>

<style>


</style>

<style scoped>

</style>
